import type { CategoryCount } from "@iltocat/shared";
import { FilterChip } from "./FilterChip.js";

/**
 * "Every category / none / one of them", as a value a query can use directly:
 * `undefined` did not ask, `null` is the uncategorised pile, a string is a
 * category. The same chip the Items screen filters with, so a category is
 * picked the same way wherever it is picked; the list narrows by typing once
 * it is long, because a category list is as long as the person makes it.
 */
export function CategoryFilter({
  categories,
  value,
  onChange,
}: {
  categories: CategoryCount[];
  value: string | null | undefined;
  onChange: (value: string | null | undefined) => void;
}) {
  return (
    <FilterChip
      label="Category"
      value={value === undefined ? undefined : (value ?? "none")}
      anyLabel="Any category"
      options={[
        { value: "none", label: "No category" },
        ...categories.map((category) => ({
          value: category.id,
          label: category.name,
          count: category.itemCount,
        })),
      ]}
      onChange={(next) => onChange(next === undefined ? undefined : next === "none" ? null : next)}
    />
  );
}
